// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__gN4DY","right":"styles_right__lxOp1"};